import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';

import { routes } from './app.routes';
import { NpAppLayoutService, NpAuthChildGuard, NpBreadcrumbService, NpPathResolver, NpUserLoginService } from '@newpla/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppPathResolver } from '@sls-nova/shared-dealer/nova-dealer-core/config/app-path-resolver';
import { NpxLoginService } from '../../../newpla-npx-ng17/src/_core/auth/npx-login-service';
import { NpLocaleService } from '../../../newpla-npx-ng17/src/_core/locale/np-locale.service';
import { NpLocaleProvider } from '../../../newpla-npx-ng17/src/_core/locale/np-locale-provider';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';

import "@grapecity/wijmo.cultures/wijmo.culture.ko";
import * as wjcCore from '@grapecity/wijmo';


import { registerLocaleData } from '@angular/common';
import localeKo from '@angular/common/locales/ko';

import { environment } from '../environments/environment';
import { NpxHttpAuthInterceptor } from '../../../newpla-npx-ng17/src/_core/auth/npx-http-auth-interceptor.service';
import { COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { AppTitleStrategy } from '@sls-nova/shared-dealer/nova-dealer-core/config/app-title-strategy';
import { NP_THEME_COMPANY_ONLY, NP_THEME_ITEMS, SLS_NOVA_ENV } from 'sls-nova-shared';


// wijmo
wjcCore.setLicenseKey(environment.wijmoLicenseKey);
wjcCore.changeCulture('ko');

registerLocaleData(localeKo);

function initializeApp(npUserLoginService: NpUserLoginService) {
  return async () => {

    await npUserLoginService.initialize().then(res => {
      console.log('initializeApp');
    })
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    //
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    // Newpla Default
    NpAuthChildGuard, AppPathResolver, NpxLoginService,
    // APP_LAY_OUT
    NpAppLayoutService, NpBreadcrumbService,
    { provide: NpPathResolver, useExisting: AppPathResolver },
    { provide: NpUserLoginService, useExisting: NpxLoginService },
    // LOCALE
    NpLocaleService, NpLocaleProvider,
    // APP CONFIG
    { provide: APP_INITIALIZER, useFactory: initializeApp, multi: true, deps: [NpUserLoginService] },
    { provide: HTTP_INTERCEPTORS, useClass: NpxHttpAuthInterceptor, multi: true },
    { provide: COMPOSITION_BUFFER_MODE, useValue: false },
    // 화주사 테마 (딜러는 화주사 테마만 쓴다: 라이트 / 다크 2개. 테마를 고른 적이 없으면 첫 번째 테마를 적용)
    { provide: SLS_NOVA_ENV, useValue: environment },
    { provide: NP_THEME_ITEMS, useValue: environment.themes },
    { provide: NP_THEME_COMPANY_ONLY, useValue: true },
    provideRouter(routes),

    // 브라우저 탭에 title을 화면마다 다르게 하기.
    Title, { provide: TitleStrategy, useClass: AppTitleStrategy },

  ]
};
